<template>
  <div class="dropdown dropdown-with-curtain" :style="style" @click.self="cancel">
    <div class="dropdown-content tv tv-list">
      <label
        for="content-hidden-file-input"
        class="tv-cell tv-cell-default tv-cell-actionable"
        data-source="fileBrowser"
        data-pepin-id="wish-more-upload"
        data-pepin-trigger="click"
        @click="select(Source.FileBrowser)"
      >
        <base-icon name="upload" class="tv-cell-thumb" />
        <div class="tv-cell-text">
          <div>{{ __('Upload') }}</div>
          <div class="small-caption-type">{{ __('Pick file from your computer.') }}</div>
        </div>
      </label>
      <div
        class="tv-cell tv-cell-default tv-cell-actionable"
        data-source="linkInput"
        data-pepin-id="wish-more-link"
        data-pepin-trigger="click"
        @click="select(Source.LinkInput)"
      >
        <base-icon name="link" class="tv-cell-thumb" />
        <div class="tv-cell-text">
          <div>{{ __('Link') }}</div>
          <div class="small-caption-type">{{ __('Enter any URL.') }}</div>
        </div>
      </div>
      <div
        class="tv-cell tv-cell-default tv-cell-actionable"
        data-source="webBrowser"
        data-pepin-id="wish-more-google"
        data-pepin-trigger="click"
        @click="select(Source.WebBrowser)"
      >
        <base-icon name="search_web" class="tv-cell-thumb" />
        <div class="tv-cell-text">
          <div>{{ __('Google') }}</div>
          <div class="small-caption-type">{{ __('Search images, videos, audio, GIFs, web.') }}</div>
        </div>
      </div>
      <label
        for="content-hidden-image-input"
        class="tv-cell tv-cell-default tv-cell-actionable"
        data-source="photoBooth"
        data-pepin-id="wish-more-snap"
        data-pepin-trigger="click"
        @click="select(Source.PhotoBooth)"
      >
        <base-icon name="camera" class="tv-cell-thumb" />
        <div class="tv-cell-text">
          <div>{{ __('Snap') }}</div>
          <div class="small-caption-type">{{ __('Take photo from your camera.') }}</div>
        </div>
      </label>
      <label
        for="content-hidden-video-input"
        :data-unsupported="!videoSupport"
        class="tv-cell tv-cell-default tv-cell-actionable"
        data-source="videoRecorder"
        data-pepin-id="wish-more-film"
        data-pepin-trigger="click"
        @click="select(Source.VideoRecorder)"
      >
        <base-icon name="videocam" class="tv-cell-thumb" />
        <div class="tv-cell-text">
          <div>
            <span>{{ __('Film') }}</span
            ><span v-if="!videoSupport" class="small-type error-type">{{ __('Not supported') }}</span>
          </div>
          <div class="small-caption-type">{{ __('Capture video from your camera.') }}</div>
        </div>
      </label>
      <div
        class="tv-cell tv-cell-default tv-cell-actionable"
        :data-unsupported="!audioSupport"
        data-source="audioRecorder"
        data-pepin-id="wish-more-voice"
        data-pepin-trigger="click"
        @click="select(Source.AudioRecorder)"
      >
        <base-icon name="mic" class="tv-cell-thumb" />
        <div class="tv-cell-text">
          <div>
            <span>{{ __('Voice') }}</span
            ><span v-if="!audioSupport" class="small-type error-type">{{ __('Not supported') }}</span>
          </div>
          <div class="small-caption-type">{{ __('Record audio from your microphone.') }}</div>
        </div>
      </div>
      <div
        class="tv-cell tv-cell-default tv-cell-actionable"
        :data-unsupported="!screenshareSupport"
        data-source="screenshareRecorder"
        data-pepin-id="wish-more-screen"
        data-pepin-trigger="click"
        @click="select(Source.ScreenshareRecorder)"
      >
        <base-icon name="screen_share" class="tv-cell-thumb" />
        <div class="tv-cell-text">
          <div>
            <span>{{ __('Screen') }}</span
            ><span v-if="!screenshareSupport" class="small-type error-type">{{ __('Not supported') }}</span>
          </div>
          <div class="small-caption-type">{{ __('Record your screen.') }}</div>
        </div>
      </div>
      <div
        class="tv-cell tv-cell-default tv-cell-actionable"
        data-source="drawingCanvas"
        data-pepin-id="wish-more-draw"
        data-pepin-trigger="click"
        @click="select(Source.DrawingCanvas)"
      >
        <base-icon name="scribble" class="tv-cell-thumb" />
        <div class="tv-cell-text">
          <div>{{ __('Draw') }}</div>
          <div class="small-caption-type">{{ __('Doodle on an onscreen canvas.') }}</div>
        </div>
      </div>
      <div
        class="tv-cell tv-cell-default tv-cell-actionable"
        data-source="mapBrowser"
        data-pepin-id="wish-more-place"
        data-pepin-trigger="click"
        @click="select(Source.MapBrowser)"
      >
        <base-icon name="place" class="tv-cell-thumb" />
        <div class="tv-cell-text">
          <div>{{ __('Place') }}</div>
          <div class="small-caption-type">{{ __('Add a location.') }}</div>
        </div>
      </div>
      <div
        class="tv-cell tv-cell-default tv-cell-actionable"
        data-source="padletBrowser"
        data-pepin-id="wish-more-padlet"
        data-pepin-trigger="click"
        @click="select(Source.PadletBrowser)"
      >
        <base-icon name="crane" class="tv-cell-thumb" />
        <div class="tv-cell-text">
          <div>{{ __('Padlet') }}</div>
          <div class="small-caption-type">{{ __('Link to one of your other padlets.') }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import BaseIcon from 'vuecomponents/base_icon'
import EscapeToCancelMixin from 'vuemixins/escape_to_cancel_mixin'
import { trackEvent } from 'bits/analytics'
import { ContentPickerSource } from 'vuexstore/modules/content_picker'

export default {
  components: { BaseIcon },
  mixins: [EscapeToCancelMixin],
  props: ['top', 'left', 'audioSupport', 'videoSupport', 'screenshareSupport', 'isPhone', 'windowWidth'],
  data() {
    return {
      topCorrection: 0,
      leftCorrection: 0,
      Source: ContentPickerSource,
    }
  },
  computed: {
    correctedLeft() {
      return this.left + this.leftCorrection
    },
    correctedTop() {
      return this.top + this.topCorrection
    },
    style() {
      if (this.isPhone || this.windowWidth < 768) {
        return {}
      }
      return { top: this.correctedTop + 'px', left: this.correctedLeft + 'px' }
    },
  },
  mounted() {
    if (!this.isPhone) {
      // hack
      const roughHeight = 568
      const roughWidth = 336
      if (this.left < 0) {
        this.leftCorrection = -this.left
      }
      if (this.left + roughWidth > window.innerWidth) {
        this.leftCorrection = window.innerWidth - (this.left + roughWidth)
      }
      if (this.top < 0) {
        this.topCorrection = -this.top
      }
      if (this.top + roughHeight > window.innerHeight) {
        this.topCorrection = window.innerHeight - (this.top + roughHeight)
      }
    }
  },
  methods: {
    cancel() {
      this.$emit('close')
    },
    select(source) {
      trackEvent('Content Menu', 'Selected Source', source)
      this.$emit('select', source)
    },
  },
}
</script>

<style lang="scss" scoped>
@import './../../assets/stylesheets/3/modules/all';
.dropdown {
  html[data-layout='map'] & {
    position: fixed;
  }
}
.dropdown-content {
  width: 320px;
}
@include respondToPhone {
  .dropdown-content {
    width: 100vw;
  }
}
.dropdown-content {
  font-size: 16px;
}
.tv-list {
  display: flex;
  flex-direction: column;
}
.tv-cell {
  flex-shrink: 0;
}
.tv-cell-text div {
  font-weight: 500;

  .error-type {
    @include directional-margin($margin-left: 12px, $margin-right: 0);
  }
}
.tv-cell-thumb {
  width: 40px;
  height: 40px;
  color: $white-color;
  padding: 8px;
  box-sizing: border-box;
  border-radius: 20px;
}
[data-source='fileBrowser'] .tv-cell-thumb {
  background-color: $material-orange-accent-700;
}
[data-source='webBrowser'] .tv-cell-thumb {
  background-color: $material-light-blue-accent-400;
}
[data-source='linkInput'] .tv-cell-thumb {
  background-color: $material-lime-accent-700;
}
[data-source='photoBooth'] .tv-cell-thumb {
  background-color: $material-yellow-accent-700;
}
[data-source='videoRecorder'] .tv-cell-thumb {
  background-color: $material-red-500;
}
[data-source='audioRecorder'] .tv-cell-thumb {
  background-color: $material-deep-purple-accent-200;
}
[data-source='drawingCanvas'] .tv-cell-thumb {
  background-color: $material-green-accent-700;
}
[data-source='mapBrowser'] .tv-cell-thumb {
  background-color: $material-blue-accent-400;
}
[data-source='padletBrowser'] .tv-cell-thumb {
  background-color: $primary-color;
}
[data-source='screenshareRecorder'] .tv-cell-thumb {
  background-color: $material-purple-accent-400;
}
[data-unsupported] {
  order: 1;
  opacity: 0.54;
}
</style>
